import { GET, POST, PUT } from "../../../../module/services/fetch";
import { map } from "rxjs/operators";

export const fetchGetWorkflowRules = () =>
  GET("admin/workflow/rules").pipe(map((response: any) => response));

export const fetchModifyWorkflowRules = (body: any[]) =>
  PUT("admin/workflow/rules", body).pipe(map((response: any) => response));

export const fetchGetAllWorkflow = () =>
  GET("admin/workflow").pipe(map((response: any) => response));

export const fetchCreateWorkflow = (body: any[]) =>
  POST("admin/workflow", body).pipe(map((response: any) => response));

export const fetchModifyWorkflow = (body: any[]) =>
  PUT("admin/workflow", body).pipe(map((response: any) => response));

export const fetchDeleteWorkflow = (body: any[]) =>
  POST("admin/workflow/delete", body).pipe(map((response: any) => response));

export const fetchGetAllWorkflowStep = () =>
  GET("admin/workflow/steps").pipe(map((response: any) => response));

export const fetchCreateWorkflowStep = (body: any[]) =>
  POST("admin/workflow/steps", body).pipe(map((response: any) => response));

export const fetchModifyWorkflowStep = (body: any[]) =>
  PUT("admin/workflow/steps", body).pipe(map((response: any) => response));

export const fetchDeleteWorkflowStep = (body: any[]) =>
  POST("admin/workflow/steps/delete", body).pipe(
    map((response: any) => response)
  );

export const fetchGetAllWorkflowStepConfiguration = () =>
  GET("admin/workflow/steps-configuration").pipe(
    map((response: any) => response)
  );

export const fetchCreateWorkflowStepConfiguration = (body: any[]) =>
  POST("admin/workflow/steps-configuration", body).pipe(
    map((response: any) => response)
  );

export const fetchModifyWorkflowStepConfiguration = (body: any[]) =>
  PUT("admin/workflow/steps-configuration", body).pipe(
    map((response: any) => response)
  );

export const fetchDeleteWorkflowStepConfiguration = (body: any[]) =>
  POST("admin/workflow/steps-configuration/delete", body).pipe(
    map((response: any) => response)
  );
